import { useEffect } from "react";
import {
  UserType,
  useRecordCmpMemberDashboardLoginMutation,
} from "../../../graphql/types";

const useRecordCmpMemberDashboardLogin = (userType: UserType | ""): void => {
  const [recordDashboardLogin] = useRecordCmpMemberDashboardLoginMutation();

  useEffect(() => {
    if (userType !== UserType.ChamberMemberAdmin) {
      return;
    }

    // Engagement telemetry must never block access to the Member Dashboard.
    // The backend record is monthly-idempotent, so refreshes and retries are
    // safe and give a transient network failure another chance to recover.
    recordDashboardLogin().catch(() => undefined);
  }, [recordDashboardLogin, userType]);
};

export default useRecordCmpMemberDashboardLogin;
